export enum Quantity {
    NONE = "none",
    ONE = "one",
    MANY = "amny",
  }
export type IQuantity = Quantity.NONE | Quantity.ONE | Quantity.MANY